/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { classnames } from "../../utils/text";
import IconButton from "../Button/IconButton";
import DeleteIcon from "../../assets/images/icon/x-icon.svg";
import DownloadIcon from "../../assets/images/icon/download-icon.svg";
import { formatBytes } from "../../utils/file";
import { loadImage, onLoadMultiImage } from "../../utils/image";
import { download } from "../../utils/download";
import Icon from "../Icon";

import { get } from 'lodash';
import ToolTip from "../ToolTip/ToolTip";

const FileInfo = ({
  files,
  selected,
  file,
  className,
  remove,
  isDownload,
  children
}) => {
  const [fileName, setFileName] = useState('');
  const [fileUrl, setFileUrl] = useState('');

  useEffect(() => {
    if (file) {
      setFileName(file?.originalName || file?.name);
      setFileUrl(file?.fileUrl);
    }
  }, [file]);

  const downOrView = async (files, selected) => {

    if (files?.length < selected) {
      return;
    }

    const url = get(files[selected], "fileUrl");
    const title = get(files[selected], "originalName");

    let check = false;
    try {
      await loadImage(url);
      check = true;
    } catch (e) { }

    if (check) {
      onLoadMultiImage(files, selected);
    } else {
      download(url, title);
    }
  };

  return (
    <div className={classnames("seleted-file-info", className)}>
      <span className="seleted-file-name"
        onClick={() => downOrView(files, selected)}
      >
        {fileName}
      </span>
      {fileName?.length > 15 && <ToolTip className="mr-3" position="top" tooltiptext={fileName} />}
      <span className="selected-file-size">
        {formatBytes(file?.size || file?.formattedSize)}
      </span>

      {remove &&
        <IconButton
          icon={DeleteIcon}
          className="delete-btn"
          onClick={() => remove(file)}
        />
      }
      {children}
      {isDownload &&
        <a className="file-download print-out" onClick={() => download(fileUrl, fileName)}>
          다운로드 <Icon src={DownloadIcon} />
        </a>
      }
    </div>
  );
};
export default FileInfo;
